import { render, staticRenderFns } from "./datasheet.vue?vue&type=template&id=8d10574c&scoped=true"
import script from "./datasheet.vue?vue&type=script&lang=js"
export * from "./datasheet.vue?vue&type=script&lang=js"
import style0 from "./datasheet.vue?vue&type=style&index=0&id=8d10574c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d10574c",
  null
  
)

export default component.exports